(() => {
  const body = document.body;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animated = new WeakSet();
  const running = new Map();
  let observer;
  const selector = '[data-reveal], .nfc-pdp-overview, .nfc-pdp-information, .nfc-collection__intro, [data-browse-card], .nfc-custom-visual, .nfc-custom-intro, .nfc-custom-step, .nfc-custom-hub-card, .cart-item, .cart-summary, .content-page > h1, .content-page > .rte, .nfc-guide-steps > li, .nfc-guide-faq > details, .page-heading, .empty-state, .password-panel';
  const enabled = () => body.dataset.nfcMotion !== 'false' && !preference.matches && !window.Shopify?.designMode;
  const complete = (element) => {
    running.get(element)?.cancel();
    running.delete(element);
  };
  const reveal = (element, delay = 0) => {
    if (animated.has(element)) return;
    animated.add(element);
    if (!enabled() || typeof element.animate !== 'function') return;
    const duration = Math.max(240, Math.min(1800, Number(body.dataset.nfcMotionDuration) || 1200));
    try {
      const animation = element.animate([
        { opacity: 0, translate: '0 8px', offset: 0 },
        { opacity: 0.45, translate: '0 3px', offset: 0.55 },
        { opacity: 1, translate: '0 0', offset: 1 }
      ], { duration, delay, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)', fill: 'backwards' });
      running.set(element, animation);
      animation.onfinish = () => running.delete(element);
      animation.oncancel = () => running.delete(element);
    } catch {
      complete(element);
    }
  };
  const scan = (root = document) => {
    if (!enabled()) return;
    const elements = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) elements.unshift(root);
    for (const element of elements) {
      if (animated.has(element) || !element.getClientRects().length || element.closest('dialog, [hidden]')) continue;
      const parent = element.parentElement?.closest(selector);
      if (parent && root.contains(parent)) continue;
      if (observer) observer.observe(element);
      else reveal(element);
    }
  };
  if (typeof window.IntersectionObserver === 'function') {
    observer = new IntersectionObserver((entries) => {
      let position = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        reveal(entry.target, Math.min(position * 65, 195));
        position += 1;
      }
    }, { threshold: 0.05, rootMargin: '0px 0px -24px 0px' });
  }
  const stop = () => {
    observer?.disconnect();
    for (const element of [...running.keys()]) complete(element);
  };
  preference.addEventListener?.('change', () => { if (!enabled()) stop(); else scan(); });
  document.addEventListener('focusin', (event) => {
    for (const element of running.keys()) if (element.contains(event.target)) complete(element);
  });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    for (const element of running.keys()) if (event.target.contains(element)) complete(element);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((element) => { observer?.unobserve(element); complete(element); });
  });
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', (event) => { if (event.persisted) scan(); });
  scan();
})();
